import React, { useEffect, useState, useRef } from "react";
import { BreathAPIs } from "../../../APIs/BreathAPIs";
import { toast, ToastContainer } from "react-toastify";
import { Table } from "antd";
import { ButtonCustom } from "../../../BootstrapComponents/ButtonCustom";
import styles from "./styles.module.css";
import { FaUsersCog } from "react-icons/fa";
import AddUserGroup from "./AddUserGroup";
import AddNewUsers from "./AddNewUsers";
import moment from "moment";
import { Switch, Divider, Button, Tag, Form, Input } from "antd";
import { MinusCircleOutlined, UserAddOutlined } from "@ant-design/icons";
import AddPermission from "./AddPermission";
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { AiFillDelete } from "react-icons/ai";
import { IoMdCloseCircle } from 'react-icons/io';



function Groups() {
  const [userGroupData, setUserGroupData] = useState([]);
  const [showAddUserGroupModal, setShowAddUserGroupModal] = useState(false);
  const [showAddNewPermissionModal, setShowAddNewPermissionModal] = useState(false);
  const [showAddNewUsersModal, setShowAddNewUsersModal] = useState(false);
  // const [searchText, setSearchText] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  const [locations, setLocations] = useState([])
  const [currentUserGroup, setCurrentUserGroup] = useState(null);
  // const [userGroupMembersData, setUserGroupMembersData] = useState([]);
  
  const [userGroupPagination, setUserGroupPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 10,
    totalPages: 0
  });
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [expandedRowData, setExpandedRowData] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState(null);
  const [isUserGroupMembersLoading, setIsUserGroupMembersLoading] = useState(false)
  const [form] = Form.useForm();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;
    fetchUserGroups(current, pageSize);
  };



  const handleExpandedTableChange = (record, pagination) => {
    const { current, pageSize } = pagination;
    getUserGroupMembers(true, record, current, pageSize, true);
  };

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record._id]);
      getUserGroupMembers(expanded, record);
      form.resetFields();
    } else {
      setExpandedRowKeys([]);
      form.resetFields();
    }
  };

  const getUserGroupMembers = async (expanded, record, page = 1, pageSize = 10, handleExpandedTableChange = false) => {
    try {


      if ((expanded && (!expandedRowData.some(item => item._id === record._id))) || handleExpandedTableChange) {
        try {

          setIsUserGroupMembersLoading(true);
          const { filterEmail, filterContact, filterFirstName, filterLastName } = form.getFieldsValue();

          let result = await BreathAPIs.getUserGroupMembersList({
            userGroupId: record._id,
            page: page,
            limit: pageSize,
            filterEmail: filterEmail ? filterEmail : null,
            filterFirstName: filterFirstName ? filterFirstName : null,
            filterLastName: filterLastName ? filterLastName : null,
            filterContact: filterContact ? filterContact : null
          });

          const data = {
            userGroupMembers: result.data.userGroupMembers,
            pagination: {
              total: result.data.pagination.total,
              current: result.data.pagination.current,
              pageSize: result.data.pagination.pageSize,
              totalPages: result.data.pagination.totalPages,
            },
          };



          setExpandedRowData(prev => {

            const exists = prev.some(item => item._id === record._id);

            if (exists) {
              return prev.map(item =>
                item._id === record._id ? { ...item, data: data } : item
              );
            } else {
              return [...prev, { _id: record._id, data: data }];
            }
          });
          setIsUserGroupMembersLoading(false);

        } catch (error) {
          console.error("Error fetching user group members:", error);
          setIsUserGroupMembersLoading(false);


        }
      }

    } catch (error) {
      console.error(error.message);

    }

  }



  const handleClearFilter = (record) => {
    form.resetFields();
    getUserGroupMembers(true, record, 1, 10, true)
  };



  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const expandedRowRender = (record) => {

    try {

      const response = expandedRowData.find((userGroup) => userGroup._id === record._id) || [];

      const expandedColumns = [
        {
          title: 'First Name',
          dataIndex: 'firstName',
          key: 'firstName',
        },
        {
          title: 'Last Name',
          dataIndex: 'lastName',
          key: 'lastName',
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
        },
        {
          title: 'Contact',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          render: (text, expandedRowRecord) => (

            <Button
              style={{ margin: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              onClick={() => {
                deleteUserGroupMembers(record._id, expandedRowRecord)
              }}

              shape="circle"
              icon={<AiFillDelete></AiFillDelete>}

              danger
            />


          ),
          width: '5rem'

        }
      ];

      return (
        <div style={{ padding: '1.5rem 2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
            <h5 style={{ margin: 0 }}>User Group Members</h5>
            <Button
              style={{
                margin: '7.5px', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
              icon={<UserAddOutlined />}
              onClick={() => {
                setShowAddNewUsersModal(!showAddNewUsersModal);
                setCurrentUserGroup(record);
              }}
              type="primary"
              disabled={!record.isActive}
            >
              Add New User
            </Button>
          </div>

          <div className={styles['filter']}>


            <Form
              initialValues={{
                filterEmail: '',
                filterContact: '',
                filterFirstName: '',
                filterLastName: '',

              }}
              form={form}
              layout="inline"

            >
              <div className={styles['filter-left']}>
                <Form.Item name="filterFirstName" >
                  <Input
                    placeholder='First Name: John'
                  />
                </Form.Item>
                <Form.Item name="filterLastName" >
                  <Input
                    placeholder='Last Name: Smith'
                  />
                </Form.Item>
                <Form.Item name="filterContact" >
                  <Input
                    placeholder='Contact: 415-555-1234'
                  />
                </Form.Item>
                <Form.Item name="filterEmail" >
                  <Input
                    placeholder="Email: eg:example@email.com"
                  />
                </Form.Item>
              </div>
            </Form>

            <div className={styles['filter-right']}>

              <Button onClick={() => {
                getUserGroupMembers(true, record, response.data.pagination.current, response.data.pagination.pageSize, true)
              }} type="primary">
                Filter
              </Button>
              <Button onClick={() => {
                handleClearFilter(record);
              }} className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} />
            </div>
          </div>

          <Table rowKey="_id" loading={isUserGroupMembersLoading} columns={expandedColumns} dataSource={response?.data?.userGroupMembers || []} onChange={(pagination) => { handleExpandedTableChange(record, pagination) }} pagination={response?.data?.pagination || []} size="small" scroll={{ x: 'calc(600px + 50%)' }} bordered />
        </div>
      );

    } catch (error) {
      console.error(error.message);
    }

  }



  async function fetchUserGroups(page = 1, pageSize = 10) {
    try {
      setIsLoading(true);
      let result = await BreathAPIs.getUserGroupsList({ page: page, limit: pageSize });
      setUserGroupData(result.data.userGroups);
      // setIsUpdateLoading(
      //   result.data.userGroups.map(userGroup => ({
      //     [userGroup._id]: false
      //   }))
      // )
      setUserGroupPagination({
        total: result.data.pagination.total,
        current: result.data.pagination.current,
        pageSize: result.data.pagination.pageSize,
        totalPages: result.data.pagination.totalPages
      });
      setIsLoading(false);
    } catch (error) {
      console.error(error.message);
      setIsLoading(false);
    }
  }

  async function getLocations(page = 1, limit = 10) {

    try {
      const res = await BreathAPIs.getLocations();
      setLocations(res.data)
    } catch (error) {
      console.error(error);
    }
  };


  const setStatus = (record, checked) => {
    try {

      const updatedUserGroup = userGroupData.map((userGroup) => {
        if (userGroup._id === record._id) {
          return { ...userGroup, isActive: checked };
        }
        return userGroup;
      });
      setUserGroupData(updatedUserGroup);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const deleteUserGroupMembers = async (userGroupId, userGroupSelectedMember) => {

    try {
      setIsUserGroupMembersLoading(true);
      
      const response = await BreathAPIs.deleteUserGroupMembers({ _id: userGroupId, userGroupMembers: [userGroupSelectedMember] });
      if (response.status === 200) {

        setExpandedRowData((prev) => {

          return prev.map((userGroup) => {
            if (userGroup._id === userGroupId) {
              return { ...userGroup, data: { pagination: response.data.data.pagination, userGroupMembers: response.data.data.userGroupMembers } }
            }
            else {
              return userGroup
            }
          })
        })
        toast.success(response.data.message)
      }

      setIsUserGroupMembersLoading(false);
      

    } catch (error) {
      console.error('Error while deleting usergroup member', error.message);
      setIsUserGroupMembersLoading(false);
      
      toast.error(error.message);

    }

  }


  const updatePermissions = (record, key) => {
    try {
      const updatedUserGroup = userGroupData.map((userGroup) => {
        if (userGroup._id !== record._id) return userGroup;

        const updatedPermissions = JSON.parse(userGroup.permissions);
        let permissionCount = 0;

        for (const permKey in updatedPermissions) {
          if (permKey.includes(key)) {
            permissionCount++;
            if (permissionCount > 1) break;
          }
        }

        if (permissionCount > 1) {
          toast.error('Please remove any associated child permissions before deleting the parent permission');
        } else {
          delete updatedPermissions[key];
        }

        return {
          ...userGroup,
          permissions: JSON.stringify(updatedPermissions),
        };
      });

      setUserGroupData(updatedUserGroup);
    } catch (error) {
      toast.error(error.message);
    }
  };



  async function updateUserGroup(record) {
    try {
    
    // setIsUpdateLoading((prev)=>{
    //   return prev.map((userGroupId)=> userGroupId === record._id ?{ userGroupId:true} : userGroupId )
    // })
      setIsUpdateLoading(record._id)
    
      if (record.isActive === false) {

        const response = expandedRowData.find((userGroup) => userGroup._id === record._id)
        setExpandedRowData((userGroups) => {
          return userGroups.map((userGroup) => userGroup._id === record._id ? { ...userGroup, data: { pagination:{ 
            total: 0,
            current: 1,
            pageSize: 10,
            totalPages: 1,

          }, userGroupMembers: [] } } : userGroup)
        })

      }
      let userGroupResponse = await BreathAPIs.updateUserGroup(record);
      //   console.log(userGroupResponse);
      userGroupResponse.status === 200
        ? toast.success(userGroupResponse.data.message)
        : toast.error(userGroupResponse.data.message);
     
        setIsUpdateLoading(null);
        // setIsUpdateLoading((prev)=>{
        //   return prev.map((userGroupId)=> userGroupId === record._id ?{ userGroupId:false} : userGroupId )
        // })
      } catch (error) {
      console.error(error.message);
      setIsUpdateLoading(null);
      // setIsUpdateLoading((prev)=>{
      //   return prev.map((userGroupId)=> userGroupId === record._id ?{ userGroupId:false} : userGroupId )
      // })
       
      }
  }

  async function deleteUserGroup(record) {

    try {

      
      const result = await BreathAPIs.deleteUserGroup(record);
      // console.log('result: ', result)
      if (result.status === 200) {

        setIsLoading(true);
        setUserGroupData(result.data.data.userGroups);
        setUserGroupPagination({
          total: result.data.data.pagination.total,
          current: result.data.data.pagination.current,
          pageSize: result.data.data.pagination.pageSize,
          totalPages: result.data.data.pagination.totalPages
        });

        setExpandedRowData((userGroups) => {
          return userGroups.filter((userGroup) => userGroup._id !== record._id)
        })
        setIsLoading(false)
        toast.success(result.data.message)
      }

      
    } catch (error) {
      console.error(error);
      setIsLoading(false)
      
    }
  }

  useEffect(() => {
    fetchUserGroups();
    getLocations();
  }, []);

  const userGroupColumn = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      render: (text, record) => (
        <span style={{ fontWeight: 500 }}> {record.groupName !== null ? record.groupName : " "}</span>
      ),
      width: screenWidth > 768 ? '12.5vw' : '25vw',
      fixed: 'left',
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 15px",
            minWidth: '215px'
          }}
        >
          <div>
            <Tag color={record.isActive ? 'green' : 'red'}>{record.isActive ? "Active" : "Inactive"}</Tag>
          </div>
          <div>
            <Switch
              onChange={(checked) => {
                setStatus(record, checked);
              }}
              checked={record.isActive}
            />
          </div>
        </div>
      ),
      width: 250,
      // fixed: 'left',
    },

    {
      title: "Permissions",
      dataIndex: "permissions",
      key: "permissions",
      render: (text, record) => (
        <div className={styles['permission-scrollbar']}>



          {record.permissions
            ? Object.entries(JSON.parse(record.permissions)).map(
              ([key, value], index, entries) => (
                <div key={key}>
                  <div
                    key={key}
                    style={{

                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: 'center',
                      width: '100%'


                    }}
                  >
                    <div>
                      <span style={{ fontWeight: 500 }}>{key}:</span>
                      <span style={{ fontStyle: "italic" }}>
                        {" "}

                        {Array.isArray(value) ? (
                          value.map((currentLocation, index) => {
                            const location = locations.find((loc) => loc._id === currentLocation);
                            if (location) {
                              return (
                                <div key={index} style={{ display: 'block' }}>
                                  {location.locationName}
                                </div>
                              );
                            }
                            return null;
                          })
                        ) : (
                          <span>{value.toString()}</span>
                        )}
                      </span>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          updatePermissions(record, key);
                        }}
                        className={styles.removeButton}
                        icon={<MinusCircleOutlined />}
                      />
                    </div>
                  </div>
                  <div>{index < entries.length - 1 ? <Divider style={{ margin: '10px 0px' }} /> : null}</div>
                </div>
              )
            )
            : "No permissions available"}
        </div>
      ),
      width: 300,
      // fixed: 'left',
    },
    {
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            onClick={() => { setShowAddNewPermissionModal(!showAddNewPermissionModal); setCurrentUserGroup(record); }}
          >
            Add / Modify Permission(s)
          </Button>

        </div>
      ),
      width: 250,
    },

    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => (
        <span>
          {record.createdAt
            ? moment(record.createdAt).format("Do MMMM YYYY, h:mm A")
            : " "}
        </span>
      ),
      width: 250,
      // fixed: 'left',
    },
    {
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Button
            style={{ margin: '8.5px' }}
            onClick={() => {
              updateUserGroup(record);
            }}
            type="primary"
            loading={isUpdateLoading===record._id?true:false }
          >
            Update
          </Button>

          <Button
            style={{ margin: '7.5px' }}
            //  shape="circle"
            //  icon={<AiFillDelete></AiFillDelete>}
            onClick={() => {
              deleteUserGroup(record);
            }}
            type="primary"
            
            danger
          >
            Delete
          </Button>


        </div>
      ),
      width: 115,
      fixed: screenWidth > 768 ? 'right' : null
    }
  ];

  return (
    <>

     
      <ToastContainer> </ToastContainer>
      <div className={styles["add-group-button"]}>
        <ButtonCustom
          text={"Create User Group"}
          icon={<FaUsersCog />}
          onClick={() => {
            setShowAddUserGroupModal(!showAddUserGroupModal);
          }}
        ></ButtonCustom>
      </div>
      {


        (
          <Table
            loading={isLoading}
            dataSource={userGroupData}
            columns={userGroupColumn}
            rowKey="_id"
            pagination={userGroupPagination}
            onChange={handleTableChange}
            bordered
            size="middle"
            expandable={{
              expandedRowRender,
              expandedRowKeys,
              onExpand: handleExpand,
            }}
            scroll={{ x: 'calc(600px + 50%)' }}
          />
        )}


      {
        showAddUserGroupModal &&
        <AddUserGroup showAddUserGroupModal={showAddUserGroupModal}
          setShowAddUserGroupModal={setShowAddUserGroupModal}
          setUserGroupData={setUserGroupData}
          locations={locations}
          setUserGroupPagination={setUserGroupPagination}
        />
      }
      {
        showAddNewUsersModal &&
        <AddNewUsers
          showAddNewUsersModal={showAddNewUsersModal}
          setShowAddNewUsersModal={setShowAddNewUsersModal}
          currentUserGroup={currentUserGroup}
          setExpandedRowData={setExpandedRowData}
          expandedRowData={expandedRowData}
        />
      }

      {
        showAddNewPermissionModal &&
        <AddPermission
          isVisible={showAddNewPermissionModal}
          setShowAddNewPermissionModal={setShowAddNewPermissionModal}
          currentUserGroup={currentUserGroup}
          setUserGroupData={setUserGroupData}
          userGroupData={userGroupData}
          locations={locations}
        />
      }
    </>


  );
}

export default Groups; 
